module.exports = __webpack_public_path__ + "img/simple3.e0ed4590.png";